module.exports = __webpack_public_path__ + "img/upload-placeholder.f3310b1f.gif";